import React, {Component} from 'react';

import {
    Link
} from 'react-router-dom';

import Api from '../Service/Api.js';

export default class ContactForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            errors: {},
            name: '',
            submitted: false,
            showNotFound: this.props.showNotFound,
            sending: false
        };

        this.resetState = this.resetState.bind(this);
    }

    resetState() {
        this.setState({
            errors: {},
            name: '',
            submitted: false,
            showNotFound: this.props.showNotFound,
            sending: false
        });
    }

    submitQuestion(event) {
        event.preventDefault();

        if (this.state.sending) {
            return false;
        }
        this.setState({sending: true, name: this.nameInput.value});

        const data = {
            name: this.nameInput.value,
            email: this.emailInput.value,
            question: this.questionInput.value,
            description: this.descriptionInput.value,
        };

        Api.requestPost('/question', data, (data) => {
            let newState = {errors: data.errors};
            newState.sending = false;
            if (data.success) {
                newState.submitted = true;
                newState.showNotFound = false;
            }
            this.setState(newState);
        }, function () {
            this.setState({sending: false});
            alert('An error occured');
        });
    }

    hasError(field) {
        return (typeof this.state.errors[field] !== 'undefined' && this.state.errors[field] !== '');
    }

    errorClass(field) {
        if (this.hasError(field)) {
            return ' has-error ';
        }
        return '';
    }

    renderError(field) {
        if (!this.hasError(field)) {
            return null;
        }
        const text = this.state.errors[field] === 'invalid' ? 'Please enter a valid e-mail' : 'This field is mandatory';
        return (
            <div className="alert alert-danger form-error">{text}</div>
        )
    }

    componentDidMount() {
        document.body.scrollTop = 0;
    }

    render() {

        const form = <form onSubmit={ event => this.submitQuestion(event) }>
            <h3>Ask a question</h3>

            <div className={"form-group " + this.errorClass('name')}>
                <label htmlFor="question_name">Your name</label>
                <input type="text" className="form-control" id="question_name"
                       ref={(input) => this.nameInput = input}
                       disabled={this.state.sending}
                       placeholder="Enter your name"/>
                {this.renderError('name')}
            </div>
            <div className={"form-group " + this.errorClass('email')}>
                <label htmlFor="question_email">Your e-mail</label>
                <input type="email" className="form-control" id="question_email"
                       ref={(input) => this.emailInput = input}
                       disabled={this.state.sending}
                       placeholder="Enter your e-mail"/>
                {this.renderError('email')}
            </div>
            <div className={"form-group " + this.errorClass('question')}>
                <label htmlFor="question_question">Your question</label>
                <input type="text" className="form-control" id="question_question"
                       ref={(input) => this.questionInput = input}
                       defaultValue={this.props.search}
                       disabled={this.state.sending}
                       placeholder="Enter your question"/>
                {this.renderError('question')}
            </div>
            <div className={"form-group " + this.errorClass('description')}>
                <label htmlFor="question_description">Your description</label>
                <textarea className="form-control" rows="5" id="question_description"
                          ref={(input) => this.descriptionInput = input}
                          disabled={this.state.sending}
                          placeholder="Enter your description"/>
                {this.renderError('description')}
            </div>
            <div className="form-group">
                <input type="submit" value="Send" className="btn btn-primary"
                       disabled={this.state.sending}/>
            </div>
        </form>;

        const successMessage = <div>
            <h3>Thank you for your question, {this.state.name}! We promise to be quite quick.</h3>
            <p><Link to={"/ask"} onClick={this.resetState}>Do you have a further question?</Link></p>
        </div>;

        const renderElement = this.state.submitted ? successMessage : form;

        const header = this.state.showNotFound ?
            <h3>Sorry, we didn't find any articles matching your search.</h3>
            : '';

        return (
            <div>
                {header}
                {renderElement}
                <Link to={"/"} onClick={event => this.props.app.setSearch('')}>Search all questions</Link>
            </div>
        );
    }
}


export class ContactSent extends Component {

    render() {
        return (
            <div>
                <h3>Your question was submitted.</h3>
                <Link to={"/"}>Back</Link>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/ContactForm.jsx